const SUBSCRIPTION_PAYMENT_ENDPOINTS = {
  SUBSCRIPTION_PAYMENT: "/frontend/create-checkout-session",
  SUBSCRIPTION_SUCCESS: "/frontend/Get-session-Details",
  PREVIEW_SUBSCRIPTION: "/frontend/preview-upgrade",
  GET_PAYMENT_TRANSECTION: "/frontend/transaction-details",
  CANCEL_SUBSCRIPTION: "/frontend/cancel-subscription",
  DISMISS_PLUS_MIGRATION: "/frontend/dismiss-plus-migration",
  START_TRIAL: "/frontend/start-trial",
};

export default SUBSCRIPTION_PAYMENT_ENDPOINTS;
